import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../../../../../modules/common/OverlayLoader.store';
import { ImageScopeName } from '../../../../annotation/question.model';
import { QuestionsList } from '../components/QuestionsList';
import { IProjectDetailsToolsBl } from '../projectDetailsTools.bl';

export const QuestionsListContainer = observer((): ReactElement => {
  const projectDetailsToolsBl = useInjection(IProjectDetailsToolsBl.$);
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const handleOrderChangeAsync = async (questionId: string, index: number, isAttribute: boolean): Promise<void> => {
    await projectDetailsToolsBl.changeQuestionOrderAsync(questionId, index, isAttribute);
  };

  return (
    <QuestionsList
      questions={projectDetailsToolsBl.store.questions.filter((q) => q.scopes.includes(ImageScopeName)).slice()}
      onOrderChange={handleOrderChangeAsync}
      isLoading={overlayLoaderStore.isSpinnerVisible('getProjectDetailsAnnotation')}
    />
  );
});
